<template lang="pug">
div
  div.StickyPlaceholder(
    ref='placeholder',
    :class='{ "is-fixed": isFixed }',
    :style='isFixed ? { "height": `${stickyContainerHeight}px` } : null'
  )

  nav.Steps.pa3-ns.cf(
    ref='nav',
    :class='{ "is-fixed": isFixed }'
  )
    a.Nav.fl.ml3(
      href='#',
      @click.prevent='currentStepIndex -= 1',
      v-if='currentStepIndex > 0'
    )
      span.NavArrow.NavArrow--Left
        include ./up.svg

      | PREV

    ul
      li(
        v-for='(step, i) in steps',
        :class='{ active: i === currentStepIndex }'
      )
        a.Gotostep( href='#' @click.prevent='currentStepIndex = i' )
          span.StepNumber {{ i + 1 }}
          span.StepText {{ step }}

    a.Nav.fr.mr3(
      href='#'
      @click.prevent='currentStepIndex += 1'
    )
      span(
        @click.prevent='currentStepIndex += 1',
        v-if='currentStepIndex < steps.length - 1'
      ) NEXT
      span.submit(
        @click.prevent='submitForm',
        v-else
      ) SUBMIT

      span.NavArrow.NavArrow--Right
        include ./up.svg
</template>

<script>

export default {

  name: 'bookart-steps',

  props: {
    disabledOptions: Array,
    steps: Array,
    value: Number,
  },

  data: () => ({
    isFixed: false,
    stickyContainerHeight: 0
  }),

  computed: {
    currentStepIndex: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },

  methods: {
    updateStickyPosition () {
      this.isFixed = (window.scrollY >= this.$refs.placeholder.offsetTop)
    },
    updateValues () {
      this.stickyContainerHeight = this.$refs.nav.offsetHeight
    },
    submitForm () {
      this.$parent.$refs.submit.submitForm()
    }
  },

  mounted () {
    window.addEventListener('resize', this.updateValues)
    window.addEventListener('scroll', this.updateStickyPosition)
    this.updateValues()
    this.updateStickyPosition()
  },

  beforeDestroy () {
    window.removeEventListener('resize', this.updateValues)
    window.removeEventListener('scroll', this.updateStickyPosition)
  },
}
</script>

<style lang="stylus" scoped>

@import '../../styles/vars'

.StickyPlaceholder:not(.is-fixed)
  height: 0

.submit
  color: $green

.Steps
  z-index: $z-top

  box-sizing: border-box
  width: 100%
  position: fixed
  bottom: 0
  left: 0

  transform: translate3d(0, 0, 0)
  background-color: $gray-light
  text-align: center

  @media $breakpoints.ns
    display: block
    position: static
    bottom: auto
    background-color: $white-almost

    border: 1px dashed $black
    border-left: none
    border-right: none

    &.is-fixed
      z-index: $z-middle
      top: -1px
      position: fixed

a.Nav
  line-height: $steps-bar-collapsed-height

  &, &:hover, &:active
    text-decoration: none
    color: $black

  display: inline-block
  @media $breakpoints.ns
    display: none

.NavArrow
  position: relative
  top: -2px

  &.NavArrow--Left
    left: -5px

    svg
      transform: rotate(-90deg)


  &.NavArrow--Right
    right: -5px

    svg
      transform: rotate(90deg)

ul
  position: absolute
  left: 50%
  transform: translateX(-50%)

  display: inline-block
  list-style: none

  padding: 0
  margin: 0
  text-align: center

  font-size: 0
  line-height: $steps-bar-collapsed-height

  @media $breakpoints.ns
    position: static
    transform: none
    display: block
    font-size: 1em
    line-height: auto

li
  display: inline-block

  &:not(:last-child)
    margin-right: 1rem

  @media $breakpoints.m
    line-height: $steps-bar-bullet-height-m
    font-size: 0.8em

    &:not(:last-child)
      margin-right: 1rem

  @media $breakpoints.l
    line-height: $steps-bar-bullet-height-l
    font-size: 1em

    &:not(:last-child)
      margin-right: 2rem

  &.active .StepNumber
    border-color: $lavender
    color: white
    background-color: $lavender

  &.active .StepText
    color: $lavender

a.Gotostep
  position: relative

  &, &:hover
    text-decoration: none

  &::after
    content: ""
    position: absolute
    left: -8px
    right: -8px
    top: -15px
    bottom: -15px

.StepNumber
  box-size: border-box

  display: inline-block
  transition: all .2s

  width: $steps-bar-bullet-height
  height: $steps-bar-bullet-height
  line-height: $steps-bar-bullet-height

  @media $breakpoints.m
    margin-right: .5rem
    width: $steps-bar-bullet-height-m
    height: $steps-bar-bullet-height-m
    line-height: $steps-bar-bullet-height-m

  @media $breakpoints.l
    margin-right: .5rem
    width: $steps-bar-bullet-height-l
    height: $steps-bar-bullet-height-l
    line-height: $steps-bar-bullet-height-l

  text-align: center
  border-radius: 50%
  border: 2px solid $gray
  color: $gray

.StepText
  color: $gray
  transition: all .2s

  display: none
  @media $breakpoints.ns
    display: inline

</style>



// WEBPACK FOOTER //
// BookartSteps.vue?258add66